(function () {
    'use strict';

    angular.module("imApp").factory("serviceObjectTypeService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1741,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1742,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
